import {Component, OnInit} from '@angular/core';

@Component({
        selector: 'eil-two-outlet-layout',
        templateUrl: './two-outlet-layout.component.html',
        styleUrls: ['./two-outlet-layout.component.scss'],
        standalone: false
    }
)
export class TwoOutletLayoutComponent implements OnInit {

    // @Input() public inputExample:    string;

    // public publicExample:            string;
    // public anotherExample:           any;

    // private privateExample:          boolean;

    constructor() {

    }

    ngOnInit() {

    }

}
